import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { TelconaCredentialsInputDTORuntype, TelconaResponseBodyDTORuntype } from './telconaBackendTypes';

export const telconaEndpoints = {
    'GET /3rdparty/telcona/credentials': endpoint({
        description: 'Returns credentials for Telcona integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: TelconaResponseBodyDTORuntype,
    }),
    'POST /3rdparty/telcona/credentials': endpoint({
        description: 'Uploads credentials for Telcona API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: TelconaCredentialsInputDTORuntype,
        responseBody: TelconaResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/telcona/credentials'],
    }),
    'PATCH /3rdparty/telcona/credentials': endpoint({
        description: 'Updates credentials for Telcona API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: TelconaCredentialsInputDTORuntype,
        responseBody: TelconaResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/telcona/credentials'],
    }),
    'DELETE /3rdparty/telcona/credentials': endpoint({
        description: 'Deletes existing credentials for Telcona API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/telcona/credentials'],
    }),
};
